import styled from '@emotion/styled';
import Image from 'next/image';
import type { PropsWithChildren } from 'react';
import { breakpointMedium } from '@/constants/breakpoints';
import { alphaHex, colors } from '@/constants/colors';
import icArrowUp from '@/public/images/ic-arrow-up.svg';

type MobileFloatingProps = {
  width?: string,
  breakpoint?: string | 'always',
  showTopButton?: boolean,
};

const topButtonSize = '48px';

const FloatingContainer = styled.div<{ breakpoint: string, width?: string }>`
position: fixed; 
z-index: 10;
right: 0;
bottom: 25px;
display: none;
width: ${({ width }) => width};
align-items: center;
justify-content: right;
padding: 0 20px;
margin-bottom: env(safe-area-inset-bottom);
transition: margin ease 100ms;
${({ breakpoint }) => breakpoint === 'always' ? `
display: flex;
` : `
@media (max-width: ${breakpoint}) {
  display: flex;
}
`}
`;

const ChildrenWrapper = styled.div`
display: flex;
width: 100%;
align-items: center;
justify-content: right;

column-gap: 12px;
& > * {
  box-shadow: 0px 7px 24px ${colors.black}${alphaHex(0.2)};
}
`;

const ToTopButtonStyled = styled.div`
display: grid;
width: ${topButtonSize};
height: ${topButtonSize};
flex-shrink: 0;
border: 1px solid ${colors.brightGrey3};
margin-left: 12px;
background-color: ${colors.white};
border-radius: 8px;
box-shadow: 0px 7px 24px ${colors.black}${alphaHex(0.2)};
cursor: pointer;
place-items: center;
`;

const ToTopButton = () => (
  <ToTopButtonStyled onClick={() => scrollTo({ top: 0, behavior: 'smooth' })}>
    <Image src={icArrowUp} alt="arrow up" />
  </ToTopButtonStyled>
);

const MobileFloating = ({
  width,
  showTopButton = true,
  breakpoint = breakpointMedium,
  children,
}: PropsWithChildren<MobileFloatingProps>) => (
  <FloatingContainer width={width} breakpoint={breakpoint}>
    <ChildrenWrapper>
      {children}
    </ChildrenWrapper>
    {showTopButton && <ToTopButton />}
  </FloatingContainer>
);

export default MobileFloating;
